import React from "react";
import { Link } from "react-router-dom";
import { NextArrow } from "../../assets/images/index";
import "./next-button.scss";

interface NextButtonProps {
  link?: string;
  className?: string;
  style?: React.CSSProperties; // Add style prop
}

export default function Index({ link, className, style }: NextButtonProps) {
  return (
    <Link
      to={{ pathname: link}}
      style={style}
      className={`next-btn ${className}`}
    >
      <img src={NextArrow} alt="NextArrow" />
    </Link>
  );
}
